import { BehaviorSubject, Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { AppConfig } from '../../app.config'
import { FlightNetwork } from './flight_network.model'
import { FlightNetworkState, VehicleState } from 'src/app/@store'

@Injectable({
  providedIn: 'root',
})
export class FlightNetworksService {
  constructor(private http: HttpClient, private appConfig: AppConfig) {
    this.refreshNetwork$()
  }

  private networkSubject = new BehaviorSubject<FlightNetwork>(new FlightNetwork({}))
  network$ = this.networkSubject.asObservable()

  refreshNetwork$(): Observable<FlightNetwork> {
    const url = this.appConfig.config.server_api.flightnetworks.get_current

    return this.http.post<FlightNetworkState>(url, {}, { withCredentials: true }).pipe(
      map((result) => new FlightNetwork(result)),
      tap((network: FlightNetwork) => this.networkSubject.next(network)),
    )
  }

  // we are not using this feature
  // getOne(id: number): Observable<FlightNetworkState> {
  //   const url: string = `${this.appConfig.config.server_api.flightnetworks.get}${id}/`
  //   return this.http.get<any>(url, { withCredentials: true })
  // }

  edit(network: FlightNetwork) {
    const url = `${this.appConfig.config.server_api.flightnetworks.edit}${network.id}/`

    // here we replace node IDs with indexes, because we have no IDs in database yet
    // and also we can't user string idForMap, because ID should be integer
    const nodesArray = [...network.nodesMap.values()]
    const nodesIndexes = new Map<string, number>(nodesArray.map((node, index) => [node.idForMap, index]))
    const flightNetworkState: FlightNetworkState = {
      ...network.toJSON(),
      edges: network.edges.map((edge) => ({
        ...edge.toJSON(),
        from_vertex_id: nodesIndexes.get(edge.fromNodeIdForMap),
        to_vertex_id: nodesIndexes.get(edge.toNodeIdForMap),
      })),
      nodes: nodesArray.map((node, index) => ({ ...node.toJSON(), id: index })),
    }
    return this.http.patch(url, flightNetworkState, { withCredentials: true })
  }
}
